if (!customElements.get('review-read-more')) {
  customElements.define('review-read-more', class ReviewReadMore extends HTMLElement {
    constructor() {
      super();
      this.characterLimit = parseInt(this.dataset.characterLimit) || 185;

      // Get text from data attributes
      let readMoreText = this.dataset.readMoreText || 'Read More';
      let readLessText = this.dataset.readLessText || 'Read Less';

      // Fallback: If Shopify translation is missing, detect and use hardcoded translations
      if (readMoreText.includes('Translation missing')) {
        // Detect language from the missing translation string
        if (readMoreText.includes('de.reviews')) {
          readMoreText = 'Mehr lesen';
          readLessText = 'Weniger lesen';
        } else if (readMoreText.includes('en.reviews')) {
          readMoreText = 'Read More';
          readLessText = 'Read Less';
        } else if (readMoreText.includes('fr.reviews')) {
          readMoreText = 'Lire la suite';
          readLessText = 'Lire moins';
        } else {
          // Default to English
          readMoreText = 'Read More';
          readLessText = 'Read Less';
        }
      }

      this.readMoreText = readMoreText;
      this.readLessText = readLessText;
      this.textWrapper = this.querySelector('.testimonials--text-wrapper');
      this.isExpanded = false;
    }

    connectedCallback() {
      if (!this.textWrapper) return;

      // Get the text content without HTML tags for length calculation
      const fullText = this.textWrapper.textContent.trim();
      const fullHTML = this.textWrapper.innerHTML.trim();

      // Only add Read More if text exceeds limit
      if (fullText.length > this.characterLimit) {
        this.fullHTML = fullHTML;
        this.fullText = fullText;

        // Create truncated version by trimming the text content
        const truncatedText = fullText.substring(0, this.characterLimit).trim() + '...';

        // For HTML content, we need to preserve the structure but truncate the text
        // Simple approach: replace the text content with truncated version
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = fullHTML;

        // Get the first text node and truncate it
        const walker = document.createTreeWalker(tempDiv, NodeFilter.SHOW_TEXT, null, false);
        let charCount = 0;
        let truncated = false;

        while (walker.nextNode()) {
          const node = walker.currentNode;
          const nodeText = node.nodeValue;
          const nodeLength = nodeText.trim().length;

          if (charCount + nodeLength > this.characterLimit && !truncated) {
            // Truncate this node
            const remaining = this.characterLimit - charCount;
            node.nodeValue = nodeText.substring(0, remaining).trim() + '...';
            truncated = true;

            // Remove all following siblings
            let nextNode = node.parentNode;
            while (nextNode && nextNode !== tempDiv) {
              let sibling = nextNode.nextSibling;
              while (sibling) {
                const toRemove = sibling;
                sibling = sibling.nextSibling;
                toRemove.remove();
              }
              nextNode = nextNode.parentNode;
            }
            break;
          }
          charCount += nodeLength;
        }

        this.truncatedHTML = tempDiv.innerHTML;

        // Set initial truncated text
        this.textWrapper.innerHTML = this.truncatedHTML;

        // Create Read More link
        this.readMoreLink = document.createElement('a');
        this.readMoreLink.href = '#';
        this.readMoreLink.className = 'review-read-more-link';
        this.readMoreLink.textContent = this.readMoreText;
        this.readMoreLink.setAttribute('aria-expanded', 'false');

        // Add click handler
        this.readMoreLink.addEventListener('click', this.toggleText.bind(this));

        // Insert Read More link after text wrapper
        this.textWrapper.parentNode.insertBefore(this.readMoreLink, this.textWrapper.nextSibling);
      }
    }

    toggleText(e) {
      e.preventDefault();

      this.isExpanded = !this.isExpanded;

      if (this.isExpanded) {
        this.textWrapper.innerHTML = this.fullHTML;
        this.readMoreLink.textContent = this.readLessText;
        this.readMoreLink.setAttribute('aria-expanded', 'true');
      } else {
        this.textWrapper.innerHTML = this.truncatedHTML;
        this.readMoreLink.textContent = this.readMoreText;
        this.readMoreLink.setAttribute('aria-expanded', 'false');
      }
    }

    disconnectedCallback() {
      if (this.readMoreLink) {
        this.readMoreLink.removeEventListener('click', this.toggleText.bind(this));
      }
    }
  });
}